import React from "react";
import PropTypes from "prop-types";
import { Row, Col, Nav, NavItem } from "reactstrap";
import { Link, useLocation } from "react-router-dom";

const TabNavigation = ({ navItems }) => {
  const location = useLocation();

  const isActive = (item) =>
    location.pathname === item.link ||
    location.pathname.startsWith(item.link + "/");

  return (
    <Row>
      <Col lg="12">
        <Nav tabs className="projectTab projectNav">
          {navItems.map((item) => (
            <NavItem key={item.id}>
              <Link
                to={item.link}
                className={`nav-link ${isActive(item) ? "active" : ""}`}
              >
                <span className="d-none d-sm-block">{item.label}</span>
              </Link>
            </NavItem>
          ))}
        </Nav>
      </Col>
    </Row>
  );
};

TabNavigation.propTypes = {
  navItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default TabNavigation;
